import { scrollToPosition } from 'common/utilities/browser/scroll/scroll';
import type { ApplicationState } from 'core/redux/reducers/rootReducer';
import type { AnyAction,Middleware } from 'redux';
import {
addIdsToSelection,   clearSelection, createSearchActiveMatch, removeIdsFromSelection,
sequenceTableLoaded, } from 'sequenceAnalyser/redux/actions/sequenceAnalyserActions';
import { sequencePixelHeight, sequencePixelWidth } from 'sequenceAnalyser/utilities/screen/screen';
import { clearResiduesSelection } from 'sequenceAnalyser/utilities/selection/selection';

const sequenceAnalyserMiddleware: Middleware<unknown, ApplicationState> = (store) => (next) => (action: AnyAction) => {
  if (addIdsToSelection.match(action) || removeIdsFromSelection.match(action) || clearSelection.match(action)) {
    clearResiduesSelection();
  } else if (createSearchActiveMatch.match(action)) {
    // Calculate the position of the match on the screen
    // and scroll to that position
    // Remove 50 pixels so it's not exactly on the edge of the browser
    const { match } = action.payload;
    const { hasColorsAndFeaturesVisible, zoomLevel } = store.getState().sequenceAnalyser;
    const calculatedSequencePixelHeight = sequencePixelHeight(
      hasColorsAndFeaturesVisible, hasColorsAndFeaturesVisible, zoomLevel,
    );
    const top = (match.sequencePosition * calculatedSequencePixelHeight) - 50;
    const left = (match.start * sequencePixelWidth(zoomLevel)) - 50;
    scrollToPosition(top, left);
  }

  if (sequenceTableLoaded.match(action)) {
    const { scrollPosition } = store.getState().sequenceAnalyser;
    if (scrollPosition) {
      window.scrollTo(scrollPosition.x, scrollPosition.y);
    }
  }

  next(action);
};

export default sequenceAnalyserMiddleware;
